import { ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';

import * as fromConfig from './config';
import { ConfigEffects } from './config/config.effects';
import * as fromDatalists from './datalists/datalists.reducer';
import { DatalistsEffects } from './datalists/datalists.effects';

import { InitializerEffects } from './initializer/initializer.effect';

export interface State {
    config: fromConfig.AppConfigState;
    datalists: fromDatalists.State;
    router: RouterReducerState;
}

export const reducers: ActionReducerMap<State> = {
    config: fromConfig.reducer,
    datalists: fromDatalists.reducer,
    router: routerReducer
};

export const effects = [
    InitializerEffects,
    ConfigEffects,
    DatalistsEffects
];
